import { render, staticRenderFns } from "./UploadInvoice.vue?vue&type=template&id=35f018c5&scoped=true&lang=pug&"
import script from "./UploadInvoice.vue?vue&type=script&lang=ts&"
export * from "./UploadInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./UploadInvoice.vue?vue&type=style&index=0&id=35f018c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f018c5",
  null
  
)

export default component.exports